import { emailRegEx, phoneNumberRegEx } from './regex';

export const inputTypeMap = {
  singleline: 'text',
  email: 'email',
  dropdown: '',
  multiline: '',
  checkboxes: '',
  hidden: '',
};

export const tagMap = {
  singleline: 'input',
  email: 'input',
  multiline: 'textarea',
  dropdown: 'select',
  checkboxes: 'checkboxes',
  hidden: 'hidden',
};

export const freeTrialFormFields = [
  {
    name: 'first_name',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'First name *',
    autocapitalize: 'on',
    validation: {
      required: 'This field is required',
    },
  },
  {
    name: 'last_name',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Last name *',
    autocapitalize: 'on',
    validation: {
      required: 'This field is required',
    },
  },
  {
    name: 'email',
    tag: 'input',
    type: 'email',
    defaultValue: '',
    helpText: 'Email *',
    validation: {
      required: 'This field is required',
      pattern: {
        value: emailRegEx,
        message: 'Please enter correct email',
      },
    },
  },
  {
    name: 'company',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Company *',
    autocapitalize: 'on',
    validation: {
      required: 'This field is required',
    },
  },
  {
    name: 'job_title',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    autocapitalize: 'on',
    helpText: 'Job title',
  },
  {
    name: 'phone_number',
    tag: 'input',
    type: 'tel',
    defaultValue: '',
    helpText: 'Phone number *',
    validation: {
      required: 'This field is required',
      pattern: {
        value: phoneNumberRegEx,
        message: 'Please enter the correct phone number',
      },
    },
  },
  {
    name: 'country',
    tag: 'select',
    type: 'country',
    required: true,
    defaultValue: '',
    helpText: 'Country *',
    validation: {
      required: 'This field is required',
    },
  },
  {
    name: 'state',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    autocapitalize: 'on',
    helpText: 'State',
  },
];

export const loginFormFields = [
  {
    name: 'username',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Username',
    validation: {
      required: 'This field is required',
    },
  },
  {
    name: 'password',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Password',
    validation: {
      required: 'This field is required',
    },
  },
];

export const forgotPasswordFormFields = [
  {
    name: 'email',
    tag: 'input',
    type: 'email',
    defaultValue: '',
    helpText: 'Your Email',
    validation: {
      required: 'This field is required',
      pattern: {
        value: emailRegEx,
        message: 'Please enter correct email',
      },
    },
  },
];

export const verificationFormFields = [
  {
    name: 'code',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Enter Verification code',
    validation: {
      required: 'This field is required',
    },
  },
];

export const newPasswordFormFields = [
  {
    name: 'password',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Enter New Password',
    validation: {
      required: 'This field is required',
    },
  },
  {
    name: 'confirmPassword',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Confirm Password',
    validation: {
      required: 'This field is required',
    },
  },
];

export const becomeMemberFormFields = [
  {
    name: 'your_name',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Your Name',
    validation: {
      required: 'This field is required',
    },
  },
  {
    name: 'your_email_address',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Your email address',
    validation: {
      required: 'This field is required',
      pattern: {
        value: emailRegEx,
        message: 'Please enter correct email',
      },
    },
  },
  {
    name: 'subject',
    tag: 'input',
    type: 'text',
    defaultValue: '',
    helpText: 'Subject',
    validation: {
      required: 'This field is required',
    },
  },
  {
    name: 'message',
    tag: 'textarea',
    type: 'text',
    defaultValue: '',
    helpText: 'Message',
    validation: {
      required: 'This field is required',
    },
  },
];
